import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Modal} from "react-bootstrap";
import DocumentList from "../components/DocumentList";

class TenderDocumentsModal extends Component {
    static propTypes = {
        tenderId: PropTypes.number.isRequired,
        clientDocuments: PropTypes.array.isRequired,
        supplierDocuments: PropTypes.array.isRequired,
        onUpload: PropTypes.func.isRequired
    };
    static defaultProps = {};
    state = {};

    render() {
        const {tenderId, clientDocuments, supplierDocuments, onUpload, ...props} = this.props;
        return (
            <Modal {...props} bsSize="large">
                <Modal.Header closeButton>
                    <Modal.Title>Документы</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ul className="nav nav-tabs nav-tabs-simple">
                        <li className={clientDocuments.length || !supplierDocuments.length ? 'active' : ''}>
                            <a href="#documents-client" data-toggle="tab">
                                Для клиента
                                {
                                    !!clientDocuments.length &&
                                    <span className="label label-info">{clientDocuments.length}</span>
                                }
                            </a>
                        </li>
                        <li className={supplierDocuments.length && !clientDocuments.length ? 'active' : ''}>
                            <a href="#documents-supplier" data-toggle="tab">
                                Для поставщика
                                {
                                    !!supplierDocuments.length &&
                                    <span className="label label-info">{supplierDocuments.length}</span>
                                }
                            </a>
                        </li>
                    </ul>
                    <div className="tab-content tab-content-bordered p-a-0">
                        <div className={`tab-pane fade ${clientDocuments.length || !supplierDocuments.length ? 'in active' : ''}`}
                             id="documents-client">
                            <DocumentList documents={clientDocuments}
                                          entityId={tenderId}
                                          entityName="Tender"
                                          propertyName="ClientDocuments"
                                          onUpload={onUpload}/>
                        </div>
                        <div className={`tab-pane fade ${supplierDocuments.length && !clientDocuments.length ? 'in active' : ''}`}
                             id="documents-supplier">
                            <DocumentList documents={supplierDocuments}
                                          entityId={tenderId}
                                          entityName="Tender"
                                          propertyName="SupplierDocuments"
                                          onUpload={onUpload}/>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        );
    }

    loadNextPage() {

    }
}

export default TenderDocumentsModal;


// WEBPACK FOOTER //
// ./src/pages/TenderBlock/Tenders/modals/TenderDocumentsModal.js